export default {
      id: "btn-shape--gold-usage",
      viewBox: "0 0 55 54",
      url: "../../assets/" + "sprite.svg#btn-shape--gold-usage",
      toString: function () {
        return this.url;
      }
    }